export enum FractionalOwnershipRoleNames {}
